import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import { capitalCase } from 'change-case'
import { isEmpty } from '../../../utils/helper'
import { CustomDescriptionBox } from '../../../../components'

const CreateRolesModal = ({
  openModal,
  setOpenModal,
  schema,
  roleData,
  updateCallback,
  addCallback,
}) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [permissions, setPermissions] = useState({})
  const [errorData, setErrorData] = useState({})

  useEffect(() => {
    if (!isEmpty(roleData)) {
      setName(roleData.name)
      setDescription(roleData.description)
      const newPermissions = {}
      Object.keys(schema).forEach((item) => {
        newPermissions[item] = roleData.permissions[item]
          ? roleData.permissions[item]
          : schema[item]
      })
      setPermissions(newPermissions)
    } else {
      setPermissions(schema)
    }
  }, [])

  const handleChange = (event, func) => {
    const { value } = event.target
    func(value)
  }
  const handlePermissionChange = (key, operation, event) => {
    const { checked } = event.target

    let temp = permissions
    temp[`${key}`][`${operation}`] = checked
    setPermissions({ ...temp })
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (!name && name.trim().length === 0) {
      isFormValid = false
      temp.name = 'Name cannot be Empty!'
    }
    // if (!description && description.trim().length === 0) {
    //   isFormValid = false
    //   temp.description = 'Description cannot be Empty!'
    // }

    setErrorData({ ...temp })
    return isFormValid
  }
  const handleSave = () => {
    if (!validateInfo()) return
    let payload = {
      name: name,
      description: description,
      permissions: permissions,
    }
    !isEmpty(roleData) ? updateCallback(payload, roleData._id) : addCallback(payload)
  }

  return (
    <>
      <CModal size="lg" visible={openModal} alignment="center" scrollable>
        <CModalHeader className="px-3 py-2">
          <CModalTitle>{isEmpty(roleData) ? `Add` : `Edit`} Role</CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow>
            <CCol lg={6}>
              <CFormLabel>Name*</CFormLabel>
              <CFormInput
                type="text"
                value={name}
                name="name"
                onChange={(e) => handleChange(e, setName)}
                disabled={!isEmpty(roleData) ? roleData?.is_system_defined : false}
              />
              <div className="message-text error-message">
                <p>{errorData.name}</p>
              </div>
            </CCol>
            <CCol lg={6}>
              <CustomDescriptionBox
                title="Description"
                rows={1}
                value={description}
                onChange={setDescription}
                limit={100}
              />
            </CCol>
          </CRow>
          <div className="mt-4 container">
            <CRow>
              <CCol className="" lg="4" />
              <CCol className="" lg="2">
                Read
              </CCol>
              <CCol className="" lg="2">
                Create
              </CCol>
              <CCol className="" lg="2">
                Edit
              </CCol>
              <CCol className="" lg="2">
                Delete
              </CCol>
            </CRow>
            {permissions &&
              Object.keys(permissions).map((key, index) => (
                <CRow key={index} className="justify-content-c">
                  <CCol className="border p-3" lg="4">
                    {capitalCase(key)}
                  </CCol>

                  <CCol className="border p-3" lg="2">
                    <CFormCheck
                      defaultChecked={permissions[`${key}`].r}
                      onChange={(e) => handlePermissionChange(key, `r`, e)}
                    />
                  </CCol>
                  <CCol className="border p-3" lg="2">
                    <CFormCheck
                      defaultChecked={permissions[`${key}`].c}
                      onChange={(e) => handlePermissionChange(key, `c`, e)}
                    />
                  </CCol>
                  <CCol className="border p-3" lg="2">
                    <CFormCheck
                      defaultChecked={permissions[`${key}`].u}
                      onChange={(e) => handlePermissionChange(key, `u`, e)}
                    />
                  </CCol>
                  <CCol className="border p-3" lg="2">
                    <CFormCheck
                      defaultChecked={permissions[`${key}`].d}
                      onChange={(e) => handlePermissionChange(key, `d`, e)}
                    />
                  </CCol>
                </CRow>
              ))}
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={() => setOpenModal(false)}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleSave}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default CreateRolesModal
